import React, {useState, useEffect} from "react";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {Card} from "reactstrap";
import Grid from "../../../components/Grid";
import {backupTrends} from "../../../utils/gridColumnDefs/backups/backupTrends";
import Stockchart from "../../../components/Stockchart";
import {formatStockChartConfig} from "../../../utils/Helpers";

export default function BackupTrend({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client } = useVsiAppContext();

    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/enterprise_backup_trend_proc?client_id=${client.clientId}`)

    const [trendData, setTrendData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [chartConfig, setChartConfig] = useState({});

    useEffect(() => {
        handleStateWithData(data?.recordset || []);
        setChartData(data?.recordset || []);
    }, [data]);

    const handleStateWithData = data => {
        const config = formatStockChartConfig(data || [], [
            {
                name: 'Used',
                field: 'used'
            },
            {
                name: 'Free',
                field: 'free'
            },
            {
                name: 'Usable',
                field: 'usable'
            }
        ]);

        setChartConfig({
            yAxis: [
                {
                    title: {
                        text: 'GiB',
                    }
                }
            ]
        });

        setTrendData(config.series);
    };

    const filterChanged = (eventData) => {
        let rowData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            rowData.push(node.data);
        });

        handleStateWithData(rowData || []);
    };

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Backup Summary Trend</VsiH4>
            <VsiBubble>
                <Stockchart
                    series={trendData}
                    config={chartConfig}
                    formatData={'{point.y:,.0f}'}
                    formatPoint={'{series.name}: <b>{point.y:,.0f}</b>'}
                />
            </VsiBubble>
            <VsiBubble>
                <Grid addStyle data={chartData}
                      filterChanged={filterChanged}
                      columnDefs={backupTrends}
                      isLoading={isLoading}/>
            </VsiBubble>
        </Card>
    )
}
